'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import Alignment from 'ContentComponents/cmv2/fields/Alignment';
import CustomWidgetField from 'DesignData/models/CustomWidgetField';
import ToolFormControl from 'DesignComponents/tool/ToolFormControl';
import { ALIGNMENT } from 'ContentUtils/constants/CustomWidgetFieldTypes';
import { DEFAULT } from 'DesignData/enums/CustomWidgetFieldAttributes';

const i18nKey = key => `DesignEditorsUI.customWidgetEditor.sidebar.fieldEdit.contentOptions.${key}`;

class AlignmentContentOptions extends PureComponent {
  constructor(...args) {
    super(...args);

    this.onDefaultChange = font => {
      this.props.editField({
        [DEFAULT]: font
      });
    };
  }

  render() {
    const {
      field,
      readOnly
    } = this.props;
    return /*#__PURE__*/_jsx("div", {
      className: "custom-widget-editor-font-picker",
      children: /*#__PURE__*/_jsx(ToolFormControl, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey(`defaultLabels.${ALIGNMENT}`)
        }),
        children: /*#__PURE__*/_jsx(Alignment, {
          onFieldChange: this.onDefaultChange,
          value: field[DEFAULT],
          readOnly: readOnly,
          buttonSize: "small"
        })
      })
    });
  }

}

AlignmentContentOptions.propTypes = {
  editField: PropTypes.func.isRequired,
  field: PropTypes.instanceOf(CustomWidgetField).isRequired,
  readOnly: PropTypes.bool
};
export default AlignmentContentOptions;